module.exports = __webpack_public_path__ + "static/media/Risk-Radiation-Plus.b11fc84f.png";